<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

const toolTipsCallBack = {
  title(tooltipItem, data) {
    return data.prefix
      ? data.prefix[tooltipItem[0].index]
      : data.labels[tooltipItem[0].index];
  }
};

export default {
  extends: Line,
  mixins: [reactiveProp],
  data() {
    return {
      options: {
        tooltips: {
          callbacks: toolTipsCallBack,
          backgroundColor: "#FFF",
          titleFontColor: "#00072B",
          bodyFontColor: "#FF6458",
          displayColors: false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                drawOnChartArea: false
              },
              ticks: {
                beginAtZero: true,
                max: 9.0,
                stepSize: 0.5
              }
            }
          ]
        },
        legend: {
          display: false
        },
        legendCallback: chart => {
          let legendsConfig = [];
          chart.data.datasets.map(item => {
            if (item.borderColor !== "transparent") {
              legendsConfig.push(
                `<li class="legend-line-chart">
                    <hr class="icon-line-dashed" style="border-color: ${item.borderColor}">
                    <span>${item.label}</span>
                </li>`
              );
            }
          });
          return `<ul class="flex flex-wrap">${legendsConfig.join("")}</ul>`;
        }
      }
    };
  },
  mounted() {
    const app = this;
    this.addPlugin({
      beforeDraw: chart => {
        const legendConfig = chart.generateLegend();
        app.$emit("generate-legend-line-chart", legendConfig);
      }
    });
    this.renderChart(this.chartData, this.options);
  }
};
</script>
<style lang="scss">
li.legend-line-chart {
  display: flex;
  align-items: center;
  margin-right: 30px;

  .icon-line-dashed {
    margin-right: 10px;
    width: 30px;
    border: none;
    border-top: 2px dashed;
    height: 1px;
  }
}
</style>
